import {NgModule} from '@angular/core';
import {DemandeurProcedureFilterComponent} from './components/demandeur-procedure-filter/demandeur-procedure-filter.component';
import {CommonModule} from '@angular/common';
import {CommonModuleP8} from '@Common/common-p8.module';
import {FlexLayoutModule} from '@Common/widgets/flex-layout/flex-layout.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAngularModule} from '@Common/mat-angular.module';
import {DateAdapter} from '@angular/material/core';
import {CustomDateAdapter} from '@Common/core/providers/custom-date-adapter';
import {EditSlugInPlaceComponent} from '../gestion/url-form/url-proposal/edit-slug-in-place/edit-slug-in-place.component';
import {UrlProposalComponent} from '../gestion/url-form/url-proposal/url-proposal.component';
import { MotifMessageResponseComponent } from './components/motif-message-response/motif-message-response.component';
import {NeoModule} from '@Common/neo-components/neo.module';
import {LdapListsSelectComponent} from "./components/ldap-lists-select/ldap-lists-select.component";

@NgModule({
  imports: [
    CommonModule,
    CommonModuleP8,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatAngularModule,
    NeoModule,
  ],
  declarations: [
    DemandeurProcedureFilterComponent,
    UrlProposalComponent,
    EditSlugInPlaceComponent,
    MotifMessageResponseComponent,
    LdapListsSelectComponent],
  exports: [
    DemandeurProcedureFilterComponent,
    UrlProposalComponent,
    EditSlugInPlaceComponent,
    MotifMessageResponseComponent,
    LdapListsSelectComponent],
  providers: [
    {provide: DateAdapter, useClass: CustomDateAdapter},
  ],
})
export class CommonDematModule { }
